<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <!-- <HeaderComponent v-if="$router.currentRoute.name != 'landing'" /> -->
    <router-view />
    <!-- <FooterComponent v-if="$router.currentRoute.name != 'landing'" /> -->

  </div>
</template>
<!-- eslint-disable-next-line max-len -->
<!-- <script type="text/javascript" src="../bower_components/xlsx-populate/browser/xlsx-populate.min.js"></script> -->
<script>
// import HeaderComponent from './components/Header.vue';
// import FooterComponent from './components/Footer.vue';

export default {
  components: {
    // HeaderComponent,
    // FooterComponent,
  },

};
</script>
<style>
.ellipsis-2-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ellipsis-5-lines {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
